import { createContext, useCallback, useContext, useMemo, useState } from "react";

const SetupGuideContext = createContext(null);

export function SetupGuideProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [focusSection, setFocusSection] = useState(null);

  // Also used directly as an onClick handler, so ignore non-string arguments (events).
  const openSetupGuide = useCallback(sectionKey => {
    setFocusSection(typeof sectionKey === "string" ? sectionKey : null);
    setDrawerOpen(true);
  }, []);
  const closeSetupGuide = useCallback(() => setDrawerOpen(false), []);

  const value = useMemo(
    () => ({
      drawerOpen,
      focusSection,
      openSetupGuide,
      closeSetupGuide,
      setDrawerOpen,
    }),
    [closeSetupGuide, drawerOpen, focusSection, openSetupGuide],
  );

  return <SetupGuideContext.Provider value={value}>{children}</SetupGuideContext.Provider>;
}

/** Same as `useSetupGuide`, but returns null outside the provider instead of throwing. */
export function useOptionalSetupGuide() {
  return useContext(SetupGuideContext);
}

export function useSetupGuide() {
  const context = useContext(SetupGuideContext);
  if (!context) {
    throw new Error("useSetupGuide must be used within SetupGuideProvider");
  }
  return context;
}
